import { useEffect, useState } from "react";

function defaultLocaleString(num: number) {
  if (!num && num !== 0) {
    return "";
  }

  const formatter = new Intl.NumberFormat("en-US");
  return formatter.format(num);
}

export default function LocaleNumber({
  number,
  className = "",
  formatter = defaultLocaleString,
}: {
  number?: number;
  className?: string;
  formatter?: (number: number) => string;
}) {
  const [localNumber, setLocalNumber] = useState<string>(
    defaultLocaleString(Number(number)),
  );

  useEffect(() => {
    if (number) {
      if (formatter) {
        setLocalNumber(formatter(number));
      } else {
        setLocalNumber(
          Number.isSafeInteger(Number(number))
            ? Number(number).toString()
            : number.toLocaleString(),
        );
      }
    }
  }, [formatter, number]);

  return <span className={className}>{localNumber}</span>;
}
